export const SIDEBAR_AREA_DRAG_HOVER_PULSE_DURATION_MS = 320;
export const SIDEBAR_AREA_DRAG_HOVER_PULSE_COUNT = 2;
export const SIDEBAR_AREA_DRAG_HOVER_EXPAND_DELAY_MS =
  SIDEBAR_AREA_DRAG_HOVER_PULSE_DURATION_MS *
  SIDEBAR_AREA_DRAG_HOVER_PULSE_COUNT;

export const SIDEBAR_AREA_HEADER_DROP_TARGET =
  'navigation-panel:area-header' as const;

export function isSidebarAreaHeaderDropTarget(
  data: Record<string, unknown>
): boolean {
  return data.at === SIDEBAR_AREA_HEADER_DROP_TARGET;
}
